import { memo } from "react";
import { FaCheckCircle } from 'react-icons/fa'

const DoComplete = ({ title, subTitle, onClose } : {
  title: string,
  subTitle?: string
  onClose : () => void
}) => {
  return (
    <div className="flex flex-col items-center justify-center gap-3">
      <FaCheckCircle size={108} className="text-green-600 "/>
      <h5>{title}</h5>
      <p className=" text-muted">{subTitle}</p>
      <button className="py-2 btn-outline-secondary" onClick={onClose}>
        ปิด
      </button>
    </div>
  );
}

export default memo(DoComplete);